<template>
  <div class="select-material">
    <NavHeaderBar :navBarTitle="navTitle" :showSearch="false" />
    <div v-show="!showSearch">

      <!-- Filter Section -->
      <div class="filter-section">
        <div class="filter-left">
          <div class="dropdown-trigger" @click="handleOper">
            <span class="label">{{ currentBrandLabel }}</span>
            <van-icon name="play" class="arrow-icon" :class="{ expanded: showBrandFilter }" />
          </div>
        </div>
        <van-icon name="search" class="search-icon" size="20" @click="handleSearch" />
      </div>
    </div>

    <!-- Search Bar -->
    <div v-show="showSearch" class="search-bar-wrapper">
      <van-search
        v-model="searchVal"
        show-action
        :placeholder="`${$t('button.search')}...`"
        @input="onSearch"
        @cancel="onCancelSearch"
      />
    </div>

    <!-- Filter Popup -->
    <van-popup v-model="showBrandFilter" position="bottom" round safe-area-inset-bottom>
      <div class="filter-popup-content">
        <div class="filter-title">{{ $t('shared.filter.filter') }}</div>
        <div class="filter-options">
          <div class="options-item" v-for="subItem in projectList" :key="subItem.id">
            <div class="options-title">{{ subItem.projectName }}</div>
            <div class="tag-content">
              <div class="filter-tag" v-for="sonItem in subItem.productList" :key="sonItem.id" :class="{ active: currentBrandValue === sonItem.id }" @click="selectTempFilter(sonItem)">{{ sonItem.productName }}</div>
            </div>
          </div>
        </div>
        <div class="filter-actions">
          <van-button block class="reset-btn" @click="resetFilter">{{ $t('button.reset') }}</van-button>
          <van-button block type="info" class="confirm-btn" @click="confirmFilter">{{ $t('button.confirm') }}</van-button>
        </div>
      </div>
    </van-popup>

    <div class="list-content">
      <!-- List Section -->
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="$t('tips.noMoreStores')"
        @load="onLoad"
        :immediate-check="false"
      >
      <van-checkbox-group v-model="checkResult">
        <van-cell-group>
          <van-cell
            v-for="(item, index) in storeSdList"
            :key="item.id"
            :title="item.customerName"
            clickable
            @click="toggleSelection(item, index)"
          >
            <template #right-icon>
              <van-checkbox :name="item.id" shape="square" ref="checkboxes" :disabled="item.isChoose" />
            </template>
            <template #title>
              <div class="store-main-content">
                <img class="store-img" v-if="item.imgUrl" src="item.imgUrl" alt="">
                <img v-else class="store-img" src="@/assets/images/icon_noimg.png" alt="">
                <div class="right-content">
                  <div class="store-info" v-if="paramsUrl.pageType === 'store'">
                    <span v-if="!['', null].includes(item.customerTag)" class="store-status txt-ellipsis" :class="item.customerTag | formatTagClass">{{ item.customerTag | formatTag }}</span>
                    <span class="store-name txt-ellipsis">{{ item.customerName }}</span>
                  </div>
                  <div class="store-info" v-else>
                    <span class="store-status txt-ellipsis" :class="{ 'tag0': item.businessType === 'Open System', 'tag2': item.businessType === 'Closed & Open System' }">{{ item.businessType }}</span>
                    <span class="store-name txt-ellipsis">{{ item.sdName }}</span>
                  </div>
                  <div class="address-info">
                    <img class="address-img" src="@/assets/images/ditu.png" alt="" />
                    <span class="address-name txt-ellipsis">{{ item.address }}</span>
                  </div>
                </div>
              </div>
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
      </van-list>
      <!-- Empty State -->
      <van-empty v-if="storeSdList.length === 0 && !loading" :description="$t('tips.noData')" />
    </div>

    <!-- Footer Action -->
    <div class="footer-action">
      <div class="right-btn" @click="confirm">
        {{ $t('button.confirm') }} ({{ currentSelectedListCount }})
      </div>
    </div>
  </div>
</template>

<script>
import NavHeaderBar from '@/components/NavHeaderBar'
import { sdAppListPageApi } from '@/api/salesDistribution'
import { customerAppDataListPageApi, visitPlanTargetIdListApi, visitPlanAddDetailApi } from '@/api/shared'
import { mapState } from 'vuex'
import { Toast, ImagePreview, Notify } from 'vant'
import { arsProjectAppQueryListApi } from '@/api/storeMaintain'
import i18n from '@/i18n'

export default {
  name: 'SelectVisitPlan',
  components: {
    NavHeaderBar
  },
  filters: {
    formatTag (value) {
      return value === 0 ? i18n.t('shared.filter.toBeVerified') : value === 1 ? i18n.t('shared.filter.sVIPCore') : value === 2 ? i18n.t('shared.filter.vIPCore') : value === 3 ? i18n.t('shared.filter.potential') : ''
    },
    formatTagClass (value) {
      return `tag${value}`
    }
  },
  data () {
    return {
      searchVal: '',
      showSearch: false,
      showBrandFilter: false,
      currentBrandValue: '',
      currentBrandLabel: this.$t('shared.listingProduct'),
      storeSdList: [],
      projectList: [],
      checkResult: [],
      loading: false,
      finished: false,
      page: 1,
      limit: 10,
      lastSearchVal: '',
      isRequesting: false,
      paramsUrl: {},
      navTitle: this.$t('shared.selectStore'),
      currentCheckedList: []
    }
  },
  computed: {
    ...mapState({
      globalData: 'globalData'
    }),
    currentSelectedListCount () {
      return this.checkResult.length
    }
  },
  async activated () {
    this.paramsUrl = this.$route.query || {}
    if (this.paramsUrl.pageType === 'store') {
      this.navTitle = this.$t('shared.selectStore')
    } else {
      this.navTitle = this.$t('shared.selectDistributor')
    }
    this.checkResult = []
    this.onCancelSearch()
    // 同步重置状态
    this.storeSdList = []
    this.page = 1
    this.finished = false
    this.loading = true // 先设置为 true，防止 van-list 立即触发 onLoad
    this.currentBrandValue = ''
    this.currentBrandLabel = this.$t('shared.listingProduct')

    try {
      const brandRes = await arsProjectAppQueryListApi()
      this.projectList = brandRes.data
    } catch (e) {
      console.log(e)
    }

    try {
      const { pageType, planId } = this.paramsUrl
      const targetRes = await visitPlanTargetIdListApi({ targetType: pageType === 'store' ? '0' : '1', planId: planId })
      this.currentCheckedList = targetRes.data
      this.checkResult = targetRes.data
    } catch (e) {
      console.log(e)
    }

    // 确保组件挂载后立即请求一次首页数据
    this.initData(true)
  },
  methods: {
    toggleSelection (item, currentIndex) {},
    handleOper () {
      this.showBrandFilter = !this.showBrandFilter
    },
    async initData (isRefresh = false) {
      // 请求锁，防止重复请求
      if (this.isRequesting) return
      this.isRequesting = true

      if (isRefresh) {
        this.page = 1
        this.finished = false
        this.loading = true
      }

      const data = {
        page: this.page,
        limit: this.limit,
        search: this.searchVal || '',
        sortField: 'distance',
        order: '0'
      }

      if (this.paramsUrl.pageType === 'distributor') {
        data.allData = true
        data.productIdList = this.currentBrandValue ? [this.currentBrandValue] : []
      }
      if (this.paramsUrl.pageType === 'store') {
        data.shelfProductIdList = this.currentBrandValue ? [this.currentBrandValue] : []
        data.shelfOperate = 0
      }

      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })

      try {
        const requestApi = this.paramsUrl.pageType === 'store' ? customerAppDataListPageApi : sdAppListPageApi
        const res = await requestApi(data)
        Toast.clear()

        // 兼容不同后端返回的分页数据结构
        let newList = []
        res.data.list.forEach(subItem => {
          if (this.currentCheckedList.includes(subItem.id)) {
            subItem.isChoose = true
          } else {
            subItem.isChoose = false
          }
        })
        newList = res.data.list

        if (isRefresh) {
          this.storeSdList = newList
        } else {
          this.storeSdList = [...this.storeSdList, ...newList]
        }

        this.loading = false

        if (newList.length < this.limit) {
          this.finished = true
        }
      } catch (error) {
        Toast.clear()
        this.loading = false
        this.finished = true
      } finally {
        this.isRequesting = false
      }
    },
    onLoad () {
      if (this.finished || this.isRequesting) return
      this.page++
      this.initData()
    },
    selectTempFilter (option) {
      this.currentBrandValue = option.id
      this.currentBrandLabel = option.productName
    },
    resetFilter () {
      this.currentBrandValue = ''
      this.currentBrandLabel = this.$t('shared.listingProduct')
      this.confirmFilter()
    },
    confirmFilter () {
      this.showBrandFilter = false
      this.initData(true)
    },
    confirm () {
      if (this.checkResult.length <= 0) {
        // 请选中计划
        Toast(this.$t('tips.pleaseSelectThePlan'))
        return
      }
      const data = {
        targetType: this.paramsUrl.pageType === 'store' ? '0' : '1',
        targetIdList: this.checkResult,
        planId: this.paramsUrl.planId
      }
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      visitPlanAddDetailApi(data).then(res => {
        Toast.clear()
        Notify({ type: 'success', message: this.$t('shared.success'), duration: 1500 })
        this.$router.replace(`/visitPlan/detail?planId=${this.paramsUrl.planId}`)
      })
    },
    onSearch () {
      // Triggered by search enter
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        clearTimeout(this.timer)
        if (this.searchVal === this.lastSearchVal) return
        this.lastSearchVal = this.searchVal
        this.initData(true)
      }, 500)
    },
    onCancelSearch () {
      this.showSearch = false
      if (this.searchVal !== '') {
        this.searchVal = ''
      }
    },
    imgPreview (url) {
      ImagePreview([url])
    },
    handleSearch () {
      this.showSearch = true
      this.$nextTick(() => {
      // this.$refs.searchRef.focus()
        this.$el.querySelector('.van-field__control').focus()
        // this.$refs.searchRef.querySelector('input').focus()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.select-material {
  min-height: 100vh;
  background-color: #fff;
  padding-bottom: 60px; // space for footer

  .filter-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px;
    background: #fff;
    border-bottom: 1px solid #eee;
    position: relative;
    z-index: 101; // Above popup

    .filter-left {
      display: flex;
      align-items: center;
    }

    .dropdown-trigger {
      display: flex;
      align-items: center;
      font-size: 13px;
      color: #333;
      cursor: pointer;

      .arrow-icon {
        font-size: 12px;
        margin-left: 6px;
        transform: rotate(90deg);
        transition: transform 0.2s;
        &.expanded {
          transform: rotate(-90deg);
        }
      }
    }

    .search-icon {
      color: #999;
      cursor: pointer;
    }
  }

  .search-bar-wrapper {
    background: #f7f8fa;
  }

  .list-content {

    .material-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 0;
      border-bottom: 1px solid #eee;

      .left-content {
        display: flex;
        align-items: flex-start;
        flex: 1;
        margin-right: 10px;

        .item-img {
          width: 45px;
          height: 45px;
          object-fit: contain;
          margin-right: 5px;
        }

        .item-info {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          min-height: 40px;

          .title-row {
            display: flex;
            align-items: center;

            .title {
              font-size: 13px;
              color: #333;
              margin-right: 6px;
            }

            .star-icon {
              font-size: 12px;
            }
          }

          .tags-row {
            display: flex;
            align-items: center;
            font-size: 12px;

            .product-name-item {
              display: flex;
              align-items: center;
              flex-wrap: wrap;
            }

            .tag {
              padding: 1px 4px;
              border-radius: 2px;
              margin-right: 3px;
              margin-bottom: 3px;
              border: 1px solid #307bff;
              color: #307bff;

              &.universal-name {
                border: 1px solid #34b032;
                color: #34b032;
              }
            }

            .inventory {
              color: #666;
            }
          }
        }
      }
    }
  }

  .footer-action {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50px;
    display: flex;
    box-shadow: 0 -2px 10px rgba(0,0,0,0.05);
    background: #fff;
    z-index: 100;

    .left-btn {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #d93026;
      font-size: 14px;
      background: #fff;
      cursor: pointer;

      .clear-text {
        font-weight: bold;
      }
      .count-text {
        font-size: 10px;
      }
    }

    .right-btn {
      flex: 1;
      background: #1989fa;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
    }
  }

  .filter-popup-content {
    padding: 16px;
    background: #fff;
    min-height: 200px;
    display: flex;
    flex-direction: column;

    .filter-title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 20px;
      text-align: center;
      color: #333;
    }

    .filter-options {
      margin-bottom: 30px;

      .options-item {
        margin-bottom: 16px;
        .options-title {
          color: #000;
          font-size: 14px;
          font-weight: bold;
          margin-bottom: 10px;
        }
        .tag-content {
          display: flex;
          flex-wrap: wrap;
          gap: 6px;
        }
      }
      .filter-tag {
        padding: 0px 10px;
        background: #f5f6f8;
        border-radius: 4px;
        font-size: 12px;
        color: #333;
        cursor: pointer;
        min-width: 80px;
        height: 30px;
        line-height: 30px;
        text-align: center;

        &.active {
          background: #e6f1fc;
          color: #1989fa;
          font-weight: 500;
        }
      }
    }

    .filter-actions {
      display: flex;
      gap: 12px;
      margin-top: auto;

      .reset-btn {
        flex: 1;
        background: #ebedf0;
        border: none;
        color: #333;
        border-radius: 6px;
      }

      .confirm-btn {
        flex: 1;
        border-radius: 6px;
      }
    }
  }
  .store-main-content {
    display: flex;
    .store-img {
      width: 50px;
      height: 50px;
      object-fit: cover;
      margin-right: 5px;
    }
    .right-content {
      flex: 1;
    }
    .store-info {
      display: flex;
      align-items: center;
      margin-bottom: 4px;

      .store-status {
        max-width: 86px;
        padding: 0px 5px;
        text-align: center;
        line-height: 16px;
        font-size: 10px;
        border: 1px solid #ee541b;
        color: #ee541b;
        background-color: #eccfc4;
        margin-right: 5px;
      }
      .tag0 {
        border: 1px solid #0db00b;
        color: #0db00b;
        background-color: #abdaaa;
      }
      .tag3 {
        border: 1px solid #7f7f7f;
        color: #7f7f7f;
        background-color: #dcdcdc;
      }

      .tag2 {
        border: 1px solid #dc851f;
        color: #dc851f;
        background-color: #f0e2d1;
      }

      .store-name {
        max-width: 180px;
        font-size: 14px;
        color: #333;
        font-weight: 500;
      }
    }
    .address-info {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #999;

      .address-img {
        width: 12px;
        height: 12px;
        margin-right: 4px;
      }
      .address-name {
        max-width: 236px;
      }
    }
  }
}
</style>
